module.exports = __webpack_public_path__ + "static/media/no-messages.ccce778f.svg";